/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetHouseholdQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


export type GetHouseholdQuery = { __typename?: 'Query', surveyHousehold: { __typename?: 'Household', spouseOrPartner: boolean, childrenOrPlanTo: boolean, buyingOrOwningHome: boolean, annualIncome: number, spouseAnnualIncome: number } };


export const GetHouseholdDocument = gql`
    query GetHousehold {
  surveyHousehold {
    spouseOrPartner
    childrenOrPlanTo
    buyingOrOwningHome
    annualIncome
    spouseAnnualIncome
  }
}
    `;
export function useGetHouseholdQuery(baseOptions?: Apollo.QueryHookOptions<GetHouseholdQuery, GetHouseholdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHouseholdQuery, GetHouseholdQueryVariables>(GetHouseholdDocument, options);
      }
export function useGetHouseholdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHouseholdQuery, GetHouseholdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHouseholdQuery, GetHouseholdQueryVariables>(GetHouseholdDocument, options);
        }
export function useGetHouseholdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHouseholdQuery, GetHouseholdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHouseholdQuery, GetHouseholdQueryVariables>(GetHouseholdDocument, options);
        }
export type GetHouseholdQueryHookResult = ReturnType<typeof useGetHouseholdQuery>;
export type GetHouseholdLazyQueryHookResult = ReturnType<typeof useGetHouseholdLazyQuery>;
export type GetHouseholdSuspenseQueryHookResult = ReturnType<typeof useGetHouseholdSuspenseQuery>;
export type GetHouseholdQueryResult = Apollo.QueryResult<GetHouseholdQuery, GetHouseholdQueryVariables>;